import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';
import { AuthenticationRoutingModule } from '../authentication/authentication-routing.module';
import { PhoneMaskDirective } from '../phone-mask/phone-mask.directive';
import { SharedModule } from '../shared/shared.module';
import { DriverJobRoutingModule } from './driver-job-routing.module';
import { JobApplyComponent } from './job-apply/job-apply.component';
import { JobCompletedComponent } from './job-completed/job-completed.component';
import { JobRejectedComponent } from './job-rejected/job-rejected.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { OnboardingAccountComponent } from './onboarding/onboarding-account/onboarding-account.component';
import { OnboardingApplyComponent } from './onboarding/onboarding-apply/onboarding-apply.component';
import { OnboardingProfileComponent } from './onboarding/onboarding-profile/onboarding-profile.component';
import { OnboardingWelcomeComponent } from './onboarding/onboarding-welcome/onboarding-welcome.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { SignUpErrorComponent } from './sign-up-error/sign-up-error.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { SignupSuccessComponent } from './signup-success/signup-success.component';
import { RecaptchaEnterpriseModule } from '../shared/recaptcha-enterprise/recaptcha-enterprise.module';

@NgModule({
  declarations: [
    LandingPageComponent,
    SignUpComponent,
    SignInComponent,
    SignupSuccessComponent,
    SignUpErrorComponent,
    JobApplyComponent,
    JobCompletedComponent,
    JobRejectedComponent,
    OnboardingWelcomeComponent,
    OnboardingAccountComponent,
    OnboardingProfileComponent,
    OnboardingApplyComponent,
  ],
  imports: [
    DriverJobRoutingModule,
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    SharedModule,
    AuthenticationRoutingModule,
    MatRadioModule,
    RecaptchaEnterpriseModule,
    FormsModule,
    MatSelectModule,
    PhoneMaskDirective,
  ],
  providers: [{ provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptchaSiteKey }],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DriverJobModule { }
